namespace Core {

    const AD_FORM_FLAGS = {
        HOTEL_SEARCH_PAGE: 'hotelSearchPage',
        EVERY_PAGE: 'everyPage',
        NEWSLETTER_SIGN_UP_SUCCESS: 'newsletterSignUpSuccess',
        PAYMENT_DETAILS_PAGE: 'paymentDetailsPage',
        BOOKING_COMPLETE_PAGE: 'bookingCompletePage',
        BOOKING_OPTIONS_PAGE: 'bookingOptionsPage',
        HOTEL_SELECTED_PAGE: 'hotelSelectedPage'
    };

    export class AdFormService {
        private flags: string[] = [];

        constructor() {
            this.flags = AdFormService.getFlags();
        }

        public isEnabledFlag(flagName: string): boolean {
            return this.flags.indexOf(flagName) !== -1;
        };

        private static getFlags(): string[] {
            if (TRPCONFIG.Domain && TRPCONFIG.Domain.AdFormTrackingFlags instanceof Array) {
                return TRPCONFIG.Domain.AdFormTrackingFlags.map(flagName => flagName.trim());
            }
            return [];
        };

        public isNewsletterSignUpEventEnabled(): boolean {
            return this.isEnabledFlag(AD_FORM_FLAGS.NEWSLETTER_SIGN_UP_SUCCESS);
        };

        public getTrackingId(): string {
            return TRPCONFIG.Domain.AdFormTrackingId;
        }
    }

    angular
        .module('core')
        .constant('AD_FORM_FLAGS', AD_FORM_FLAGS)
        .service('adFormService', AdFormService);
}
